import { FormSection } from '@ksyos/design-system';
import { useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';
import { ProcessActivityAllergiesRead } from './components/processActivityAllergies/ProcessActivityAllergiesRead';
import { ProcessActivityEpisodesAndJournalsRead } from './components/processActivityEpisodesAndJournals/ProcessActivityEpisodesAndJournalsRead';
import { ProcessActivityLabResultsRead } from './components/ProcessActivityLabReasultsRead';

interface ProcessActivityProfessionalSummaryDataReadProps {
    processActivityId: string;
}
export function ProcessActivityProfessionalSummaryDataRead(props: ProcessActivityProfessionalSummaryDataReadProps) {
    const { processActivityId } = props;
    const language = getSelectedLanguage();
    const [showComponent, setShowComponent] = useState(false);

    return (
        <FormSection
            isBorderless={!showComponent}
            title={showComponent ? language.professionalSummary.professionalSummary : undefined}
        >
            <ProcessActivityAllergiesRead
                processActivityId={processActivityId}
                showParent={showParent}
            />
            <ProcessActivityLabResultsRead
                processActivityId={processActivityId}
                showParent={showParent}
            />
            <ProcessActivityEpisodesAndJournalsRead
                processActivityId={processActivityId}
                showParent={showParent}
            />
        </FormSection>
    );

    function showParent() {
        setShowComponent(true);
    }
}
